<template>
  <a-form-item
    class="form-subject-field stc-ant-field-skin"
    label="Тема обращения"
    name="subject"
    required
  >
    <a-select
      class="form-subject-field__select"
      :value="modelValue"
      placeholder="Выберите тему"
      @update:value="emit('update:modelValue', $event)"
    >
      <a-select-option
        v-for="opt in options"
        :key="opt.value"
        :value="opt.value"
      >
        {{ opt.label }}
      </a-select-option>
    </a-select>
  </a-form-item>
</template>

<script lang="ts" setup>


export interface FormSubjectOption {
  value: string;
  label: string;
}

defineProps<{
  modelValue: string;
  options: FormSubjectOption[];
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();
</script>
